export const frontendModules = [
  ['candidato', 'Candidato', 'https://candidato.ontest.com.br'],
  ['camera_externa', 'Câmera externa', 'https://candidato-external.ontest.com.br'],
  ['avaliador', 'Avaliador', 'https://avaliador.ontest.com.br'],
  ['fiscal', 'Fiscal', 'https://fiscal.ontest.com.br'],
  ['elaborador', 'Elaborador', 'https://elaborador.ontest.com.br'],
  ['admin', 'Administrativo', 'https://admin.ontest.com.br'],
  ['corretor', 'Corretor', 'https://corretor.ontest.com.br'],
];

export function frontendUrl(module, organization, path = '') {
  const fallback = frontendModules.find(([key]) => key === module)?.[2] || '';
  const base = organization?.frontend_urls?.[module] || organization?.frontend_domains?.[module] || fallback;
  return base.replace(/\/+$/, '') + (path ? '/' + path.replace(/^\/+/, '') : '');
}
